module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.toolbarLoading),
      expression: "toolbarLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [(_vm.adminRole) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("CSV出力")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新規追加")])], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 30,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.movies,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状況",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 'uploaded') ? _c('span', [_vm._v("処理中")]) : (scope.row.status === 'uploading') ? _c('span', [_vm._v("アップロード中")]) : (scope.row.status === 'uploadError') ? _c('span', [_vm._v("失敗")]) : (scope.row.status === 'transcoding') ? _c('span', [_vm._v("変換中")]) : (scope.row.status === 'transcoded') ? _c('span', [_vm._v("トランスコード変換完了")]) : (scope.row.status === 'drmConverting') ? _c('span', [_vm._v("DRM変換中")]) : (scope.row.status === 'drmConvertError') ? _c('span', [_vm._v("DRM変換エラー")]) : (scope.row.status === 'completed' && scope.row.drmStatus) ? _c('span', [_vm._v("完了")]) : (scope.row.status === 'completed' && !scope.row.drmStatus) ? _c('span', [_vm._v("完了T")]) : _c('span', [_vm._v("エラー")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "動画名",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.name) + "\n                "), (scope.row.mode == 2) ? _c('span', [_vm._v("\n                    (" + _vm._s(scope.row.mode) + "D)\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.mode == 3) ? _c('span', [_vm._v("\n                    (" + _vm._s(scope.row.mode) + "D)\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.mode == 4) ? _c('span', [_vm._v("\n                    (SbS)\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.mode == 5) ? _c('span', [_vm._v("\n                    (T&B)\n                ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "動画時間",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.duration > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("hhMMss")(scope.row.duration)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "プレビュー",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.previewVisible = true;
              _vm.previewSource = scope.row.id
            }
          }
        }, [_vm._v("\n                    プレビュー\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "コンテンツ名",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.contents)), function(content, key) {
          return _c('div', {
            key: key
          }, [_vm._v("\n                    " + _vm._s(content) + "\n                ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新日時",
      "width": "210",
      "prop": "updatedAt",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(scope.row.updatedAt)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.role !== 'general') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.role !== 'general') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("削除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.role !== 'general') ? _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("一括削除")])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新規追加",
      "close-on-click-modal": false,
      "before-close": _vm.closeAddForm
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "150px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "動画名接頭辞",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    on: {
      "change": _vm.onChangeAddForm
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "トランスコード設定",
      "prop": "transcodeModeId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "選択して下さい",
      "disabled": ""
    },
    model: {
      value: (_vm.addForm.transcodeModeId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "transcodeModeId", $$v)
      },
      expression: "addForm.transcodeModeId"
    }
  }, _vm._l((_vm.addFormTranscodeMode), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画",
      "prop": "path"
    }
  }, [(_vm.addFormInputFileDisabled) ? _c('div', {
    staticClass: "el-form-item__error",
    staticStyle: {
      "position": "initial !important"
    }
  }, [_c('p', [_vm._v("動画接頭辞の入力内容を確認してから動画を選択してください")])]) : _vm._e(), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "multiple": "",
      "accept": "video/mp4,video/x-m4v,video/*",
      "before-upload": _vm.beforeUpload,
      "on-change": _vm.onChange,
      "auto-upload": "",
      "on-progress": _vm.onProgress,
      "before-remove": _vm.beforeRemove,
      "http-request": _vm.httpRequest,
      "file-list": _vm.addFileList,
      "disabled": _vm.addFormInputFileDisabled
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeAddForm($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "編集",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeEditForm
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "150px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ID",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "id", $$v)
      },
      expression: "editForm.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "トランスコード設定",
      "prop": "transcodeMode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "選択して下さい",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.transcodeModeId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "transcodeModeId", $$v)
      },
      expression: "editForm.transcodeModeId"
    }
  }, _vm._l((_vm.allTranscodeMode), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "動画パス"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.path),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "path", $$v)
      },
      expression: "editForm.path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作成日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "作成日時",
      "format": "yyyy/MM/dd HH:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.createdAt),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "createdAt", $$v)
      },
      expression: "editForm.createdAt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "更新日時",
      "format": "yyyy/MM/dd HH:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "updatedAt", $$v)
      },
      expression: "editForm.updatedAt"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditForm($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("登録")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "プレビュー",
      "size": "full",
      "close-on-click-modal": false
    },
    on: {
      "open": function($event) {
        return _vm.play()
      }
    },
    model: {
      value: (_vm.previewVisible),
      callback: function($$v) {
        _vm.previewVisible = $$v
      },
      expression: "previewVisible"
    }
  }, [_c('video', {
    ref: "video",
    attrs: {
      "width": "720px",
      "controls": "",
      "autoplay": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c7c6aaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/Movie.vue
// module id = 1138
// module chunks = 1